module.exports = __webpack_public_path__ + "static/media/GlacialIndifference-Italic.cec8fc35.woff2";